module.exports = __webpack_public_path__ + "img/box-memo.8274e5bc.svg";